import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController, ToastController } from 'ionic-angular';

import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';
import { ItemSliding } from 'ionic-angular';

import { HomePage } from '../home/home';
import { CalendarLeistungListePage } from '../calendar-leistung-liste/calendar-leistung-liste';

/**
 * Generated class for the CalendarPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-calendar',
  templateUrl: 'calendar.html',
})
export class CalendarPage {

  constructor(public navCtrl: NavController, 
  	private rhynoApi: RhynoApiProvider, 
  	public loadingCtrl: LoadingController, 
  	public navParams: NavParams,
  	public toastCtrl: ToastController,
    public modalCtrl: ModalController) {
  	//this.getData();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CalendarPage');
  }
  ionViewWillEnter(){
    this.getData();
  }

  Calendar = [];

  loading: any;

  public barChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartLabels:string[] = [];
  public barChartType:string = 'horizontalBar';
  public barChartLegend:boolean = true;
 
  public barChartData:any[] = [
    {data: [], label: 'Menge in Stunden'}
  ];


 	getData(){
  	this.loading = this.loadingCtrl.create({
		  content: 'einen Moment...'
	  });
  	this.loading.present();

  	this.rhynoApi.getErfassungscontrolling({}).subscribe(
  		data => {
  		if (data.success){
  			this.Calendar = data.data; 
        console.log(this.Calendar)
        this.Calendar.forEach(item => {
          item.day = new Date(item.Datum).getDay();
          if (item.MengeExtern){
            item.progress = 100/24*item.MengeExtern;
          } else {
            item.progress = 0;
            item.MengeExtern = 0;
          }
          if (item.day>=1 && item.day<=5){
            if (item.MengeExtern==0){
              item.status = 'ERROR' 
            } else {
              if (item.MengeExtern>=8){
                item.status = 'OKFULL' 
              } else {
                item.status = 'OK' 
              }
            }
          } else {
            if (item.MengeExtern==0){
              if (item.MengeExtern>=8){
                item.status = 'OKFULL' 
              } else {
                item.status = 'OKWEEKEND'
              }
              
            } else {
              if (item.MengeExtern>=8){
                item.status = 'OKFULL' 
              } else {
                item.status = 'OKFULL'
              }
            }
          }
        })
  		}else{
        this.presentToast(data.message, 'error');
      }

      this.loading.dismiss();

  	},
  		err => {
  		console.log(err);
  		this.loading.dismiss();
  	},
  	() => console.log('Inbox Search Complete')
  	);
  }
  // events
  public chartClicked(e:any):void {
    console.log(e);
  }
 
  public chartHovered(e:any):void {
    console.log(e);
  }

   presentToast(message,type) {
    var style = '';
    switch (type) {
       case "success":
         style = 'toast-success';
         break;
       case "error":
         style = 'toast-error';
         break;
     } 

    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top',
      showCloseButton: false,
      cssClass: style
    });
    toast.present();
  }

  doRefresh(refresher){
    this.getData();
    refresher.complete();
  }
  newLeistung(item, slidingItem: ItemSliding){
    let data = {
      presettings: {
        Datum: item.Datum
      }
    };
    this.navCtrl.push(HomePage, data);
    slidingItem.close();
  }
  select(item){
    console.log('select')
    this.navCtrl.push(CalendarLeistungListePage, item);
    //let profileModal = this.modalCtrl.create(CalendarLeistungListePage, item);
   //profileModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/calendar/calendar.ts